import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";

import { Fetch, ILazyParams } from "../../shared/Fetch";
import { IPermissionProps } from "../../models/Login";
import { InputText } from "primereact/inputtext";
import { Search } from "../../shared/Search";
import { IModel } from "./TeamMemberList";
import { EmptyTeam } from "./EmptyTeam";
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptySkillFilter, Filter, ISkillFilter } from "./Filter";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    permissions: IPermissionProps,
    setReload: (is: boolean) => void,
    setModal2: (modal: {
        open: boolean,
        singleData: RowData
    }) => void,
}

export interface ITeamMast {
    branch?: string,
    company?: string,
    team_ID?: number,
    team_Manager?: string,
    team?: string,
    role_ID?: number,
}

export interface RowData {
    branch?: string,
    branch_ID?: number,
    company?: string,
    company_ID?: number,
    createdOn?: Date,
    status?: boolean,
    team_ID?: number,
    team_Manager?: string,
    team_Manager_ID?: number,
    team_Name?: string,
    user_Added_by?: number,
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITeamMast>, loading: boolean });
    const [defaultTableData, setDefaultTableData] = useState({ tableData: [] } as { tableData: Array<ITeamMast> });
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'consultant_ID',
        sortOrder: -1
    });
    const [skillFilter, setSkillFilter] = useState<ISkillFilter>(EmptySkillFilter);

    const dt = useRef<any>(null);


    const exportCSV = () => {
        dt.current.exportCSV();
    };



    const rightToolbarTemplate = () => {
        //     <React.Fragment>
        //         <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
        //     </React.Fragment> : ''
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Team Member List</h5>
            <span className="block mt-2 md:mt-0 p-input-icon-left">
                <i className="pi pi-search" />
                <InputText placeholder="Search By Team Name" onChange={(e) => {
                    let data = defaultTableData.tableData.filter(el => el.team?.toLowerCase().includes(e.target.value.toLowerCase()));
                    setTableData({ tableData: data, loading: false });
                }} />
            </span>
        </div>
    );

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Team_Mast/teamMemberList", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filters=${JSON.stringify(skillFilter)}`, props.toast);
        if (response) {
            const data: Array<ITeamMast> = await response.json();
            setTableData({ tableData: data, loading: false });
            setDefaultTableData({ tableData: data });
        }
    }


    useEffect(() => {
        if (lazyParams.rows) {
            loadTableData();
        } else {
            loadTableData();
        }
    }, [lazyParams, props.reload, skillFilter]);



    return (
        <>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter skillFilter={skillFilter} setSkillFilter={(skillFilter: ISkillFilter) => setSkillFilter(skillFilter)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh"
                sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                value={tableData.tableData}
                emptyMessage="No Requirements found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="team" header="Team Name" />
                <Column field="company" header="Company" />
                <Column field="" header="Team Type" body={(rowData: ITeamMast) => <span>{rowData?.role_ID === 2 ? "Sales" : "Recruiter"}</span>} />
                <Column field="branch" header="Branch" />
                <Column field="team_Manager" header="Team Manager" />
                <Column field="team_Member" header="Team Member" />
            </DataTable>
        </>
    );
}